export const PROPOSAL_LIST_BUDGETS = 'proposal/list/budgets'
